import { createContext, useContext } from "react";

export const LicenseContext = createContext({
  status: null,       // LicenseStatusDto from the server
  loading: true,
  error: null,
  isOperational: true,
  mode: "Community",
  tier: "community",
  hasFeature: () => true,
  // True once GET /api/license/status has come back (either way). hasFeature() answers optimistically
  // before that, so a licensed customer never watches a paid feature flicker off and on during load —
  // but a component must NOT fire a licence-gated REQUEST on that optimistic answer, or an unlicensed
  // site gets a burst of 403s on every page load. Guard gated fetches with this; guard rendering with
  // hasFeature() alone. Defaults to true so a consumer mounted outside the provider keeps today's
  // behaviour rather than silently never fetching.
  featuresResolved: true,
  refresh: async () => {},
});

export const useLicense = () => useContext(LicenseContext);
